export const { REACT_APP_GCP_RECAPTCHA_SITE_KEY: GCP_RECAPTCHA_SITE_KEY } = process.env;
